import { service } from '../../../../helpers/http'

export const ActionWorkLoadBalanceSubperiod = ({ dispatch }, payload) => {

    return service({
        module: 'controlPanel',
        action: 'workLoadBalanceSubperiod',
        payload: payload
    })

}
